<template lang="pug">
#modal-visualizar-laudos-vinculados
    el-dialog(
        width='40%',
        title='Laudos vinculados',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        main
            h3.mb-3 Empresa: {{ empresa.nomeEmpresa }}
            h3 Laudos:
            ul(v-loading='buscandoLaudos')
                li(v-for='laudo in laudosVinculados') {{ laudo.nome }}

        footer(slot='footer')
            BaseButton(size='mini', @click='fechar') Voltar
</template>

<script>
import LaudoEmpresaService from '@/services/LaudoEmpresaService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVisualizarLaudosVinculados',

    components: {
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        empresa: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            laudosVinculados: [],
            buscandoLaudos: false
        };
    },

    watch: {
        mostrar() {
            if (this.mostrar) {
                this.buscarLaudos();
            }
        }
    },

    methods: {
        async buscarLaudos() {
            this.buscandoLaudos = true;

            const { data } = await LaudoEmpresaService.buscarLaudosPorEmpresa(
                this.empresa.idEmpresa
            );
            this.laudosVinculados = data.itens;
            this.buscandoLaudos = false;
        },

        fechar() {
            this.laudosVinculados = [];
            this.$emit('fechar');
        }
    }
};
</script>
